type FieldInfo = {
  code: string | number;
  message: string;
};

export type ParsedApiError = {
  fields: Record<string, FieldInfo>;
  details?: {
    message: string;
    code: string | number;
  };
};

/**
 * Parse a 400 Bad Request response body into a structured error object.
 *
 * Handles two response formats from the backend:
 * 1. Global errors: { non_field_errors: [{ message, code }] }
 * 2. Field-level errors: { field_name: [{ message, code }] }
 */
export function parseClientError(data: unknown): ParsedApiError {
  const obj = data as Record<string, unknown> | null | undefined;
  if (obj && obj.non_field_errors) {
    return {
      details: (obj.non_field_errors as FieldInfo[])[0],
      fields: {},
    };
  }

  const fields: Record<string, FieldInfo> = {};
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (Array.isArray(value) && value.length > 0) {
        fields[key] = value[0] as FieldInfo;
      }
    });
  }
  return {fields};
}
